import type { AxiosRequestConfig } from 'axios';
import API from './ApiBase';
import { AIJobStatusResponse } from '../types/AIJob.types';

type ApiRequestConfig = AxiosRequestConfig & { skipErrorToast?: boolean };

export const getAIJobStatus = async (
  jobId: string,
  options?: { suppressErrorToast?: boolean }
): Promise<AIJobStatusResponse> => {
  const config: ApiRequestConfig = {};

  if (options?.suppressErrorToast) {
    config.skipErrorToast = true;
  }

  const response = await API.get<AIJobStatusResponse>(
    `/python-ai/jobs/${jobId}`,
    config
  );
  return response.data;
};
